import React from 'react';
import styled from 'styled-components';
import SVG from 'react-inlinesvg';
import AniLink from 'gatsby-plugin-transition-link/AniLink';
import RestaurantsDelivery from '../../sections/RestaurantsDelivery';

const Wrapper = styled.section`
  position: relative;
  width: 100%;
  background: #131313;
  background: linear-gradient(180deg, rgba(17,17,17,0) 0%, rgba(17,17,17,1) 10%);
  background-repeat: no-repeat;
  background-size: cover;
  margin-top: -150px;
`

const Container = styled.div`
  position: relative;
  align-items: center;
  margin: 0 auto;
  padding: 100px 30px;
  width: 100%;
  max-width: ${({ theme }) => theme.sizes.maxContentWidth};

  > div {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  ${({ theme }) => theme.media.l} {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    min-height: 100vh;
    > div {
      width: 100%;
    }
  }
`

const RestaurantsLogoList = styled.ul`
  width: calc(100% + 60px);
  height: 250px;
  margin: 0 -30px 60px;
  white-space: nowrap;
  overflow-x: scroll;
  overflow-y: hidden;

  display: flex;

  ::-webkit-scrollbar {
    width: 12px;
    background-color: rgba(0, 0, 0, 0);
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 8px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: ${({ theme }) => theme.colors.primary};
  }

  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 8px;
    background-color: rgba(0, 0, 0, 0);
  }

  ${({ theme }) => theme.media.l} {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: auto;
    margin: 0 0 60px;
    overflow-x: hidden;
    white-space: wrap;
    padding: 80px;
  }

  ${({ theme }) => theme.media.xl} {
    margin: 0;
  }
`

const RestaurantsLogoItem = styled.li`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 200px;
  height: 200px;
  margin: 0;
  padding: 0 20px;
  cursor: pointer;

  flex-shrink: 0;

  svg {
    width: 85%;
  }

  img {
    display: block;
    width: 85%;
  }

  :after {
    pointer-events: none;
    position: absolute;
    top: 6px;
    right: 6px;
    bottom: 6px;
    left: 6px;
    border: 3px solid ${({ theme }) => theme.colors.primary};
    opacity: ${({ isActive }) => (isActive ? '1' : '0')};
    transition: opacity 1.2s ease;
    content: '';
  }

  :first-of-type {
    margin-left: 30px;
  }

  :last-of-type {
    margin-right: 0px;
  }

  ${({ theme }) => theme.media.l} {
    display: flex;
    width: 33%;
    height: auto;

    :first-of-type {
      margin-left: 0;
    }

    :last-of-type {
      margin-left: 0;
    }
  }

  ${({ theme }) => theme.media.xl} {
    width: 20%;
  }
`

const RestaurantsList = ({ restaurantsList }) => {

  const Icon = ({ filename }) => {
    //console.log(filename); return false;
    const req = require.context(`../../assets/svg/restaurants`, true, /\.svg$/)
    const IconTag = req(`./${filename}.svg`)

    return <SVG src={IconTag} />
  }

  //console.log(restaurantsList)

  return (
    <Wrapper id="portfolio">
      <Container>
        <div>
          <RestaurantsLogoList>
            {restaurantsList.map((item, index) => (
              <RestaurantsLogoItem
                key={item.node.id}
                /*isActive={
                  currentItem ? currentItem.node.id === item.node.id : false
                }
                onClick={() => handleItemChange(item)}*/
              >
                {

                (item.node.slug === 'duck-and-waffle') 

                ?

                <a
                  href={`https://www.duckandwaffle.com.hk/`}
                  target="blank"
                >
                  {item.node.logo.extension === 'svg' ? (
                  <Icon filename={item.node.slug} />
                  ) : (
                    <img src={item.node.logo.childImageSharp.fluid?.src} alt={item.node.name} />
                  )}
                </a>
                
                :
                <AniLink
                  cover
                  direction="left"
                  bg="#171717"
                  to={`/portfolio/${item.node.slug}`}
                  duration={2}
                  isD={false}
                  style={{ display: 'block' }}
                >
                {item.node.logo.extension === 'svg' ? (
                  <Icon filename={item.node.slug} />
                ) : (
                  <img src={item.node.logo.childImageSharp.fluid?.src} alt={item.node.Name+' logo'} />
                )}
                </AniLink>
                }  
              </RestaurantsLogoItem>
            ))}
            <RestaurantsLogoItem
              key={`bombay_to_go`}
            >
              <RestaurantsDelivery restaurant={{}} home />
            </RestaurantsLogoItem>
          </RestaurantsLogoList>
        </div>
        {/*<RestaurantDetails id="restaurant-details" isVisible={!loading}>
          <TextHeader>{currentItem ? currentItem.node.Name : ''}</TextHeader>
          <Paragraph center subtitle>
            {currentItem
              ? currentItem.node.slogan
              : ''}
          </Paragraph>
          <Paragraph center>
            {currentItem
              ? currentItem.node.shortDescription
              : ''}
          </Paragraph>
          <div>
            {currentItem.node.bookingsId && (
              <a
                href={`https://app.optitable.com/en/reservation/?rid=${currentItem.node.bookingsId}`}
                target="blank"
              >
                <Button>Book now</Button>
              </a>
            )}
            {
              (currentItem.node.slug == 'duck-and-waffle') 

              ?

              <a
                href={`https://www.duckandwaffle.com.hk/`}
                target="blank"
              >
                <Button>Read more</Button>
              </a>
              

              :

              <AniLink
              cover
              direction="left"
              bg="#171717"
              to={currentItem ? `/portfolio/${currentItem.node.slug}` : '/'}
              duration={2}
              isD={false}
            >
              <Button>Read more</Button>
            </AniLink>
              
            }
          </div>
          </RestaurantDetails>*/}
      </Container>
    </Wrapper>
  )
}

export default RestaurantsList
